var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "mb-4" },
        [
          _c(
            "v-col",
            {
              attrs: { cols: "12", lg: "6" },
              on: {
                click: function($event) {
                  _vm.selectedSlot = "pro"
                }
              }
            },
            [
              _c(
                "va-card",
                {
                  staticClass:
                    "pa-6 d-flex flex-column align-center cursor-pointer",
                  class: [
                    _vm.selectedSlot === "pro"
                      ? "border-primary-a"
                      : "border-align"
                  ]
                },
                [
                  _c("windows-logo"),
                  _c("h2", { staticClass: "mt-3 font-bold" }, [
                    _vm._v(_vm._s(_vm.$t("software.magoOnWin")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              attrs: { cols: "12", lg: "6" },
              on: {
                click: function($event) {
                  _vm.selectedSlot = "display"
                }
              }
            },
            [
              _c(
                "va-card",
                {
                  staticClass:
                    "pa-6 d-flex flex-column align-center cursor-pointer",
                  class: [
                    _vm.selectedSlot === "display"
                      ? "border-primary-a"
                      : "border-align"
                  ]
                },
                [
                  _c("android-logo"),
                  _c("h2", { staticClass: "mt-3 font-bold" }, [
                    _vm._v(_vm._s(_vm.$t("software.magoOnAndroid")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.selectedSlot === "pro" || _vm.selectedSlot === "essential"
        ? _c("software-version-row", {
            staticClass: "mb-4",
            attrs: {
              icon: "vi vi-room",
              title: _vm.$t("software.room"),
              note1: _vm.room,
              note2: _vm.roomFastchannel
            }
          })
        : _vm._e(),
      _vm.selectedSlot === "pro"
        ? _c("software-version-row", {
            staticClass: "mb-4",
            attrs: {
              icon: "vi vi-controller",
              title: _vm.$t("software.controller"),
              note1: _vm.controllerIos,
              note2: _vm.controllerAndroid
            }
          })
        : _vm._e(),
      _vm.selectedSlot === "pro" || _vm.selectedSlot === "essential"
        ? _c("software-version-row", {
            staticClass: "mb-4",
            attrs: {
              icon: "vi vi-app",
              title: _vm.$t("software.app"),
              note1: _vm.appIos,
              note2: _vm.appAndroid
            }
          })
        : _vm._e(),
      _vm.selectedSlot === "display"
        ? _c(
            "software-version-row",
            {
              staticClass: "mb-4",
              attrs: {
                icon: "vi vi-room",
                title: _vm.$t("software.magoForDisplay"),
                note1: _vm.roomAndroid
              }
            },
            [_c("software-mago-display")],
            1
          )
        : _vm._e(),
      _vm.selectedSlot === "display"
        ? _c("software-version-row", {
            staticClass: "mb-4",
            attrs: {
              icon: "vi vi-controller",
              title: _vm.$t("software.controller"),
              note1: _vm.controllerIos,
              note2: _vm.controllerAndroid
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }